import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Vehiculos from "./components/vehiculos";
import Conductores from "./components/Conductores";
import SignIn from "./pages/SignIn/sign-in/SignIn";
import ProtectedRoute from './components/utilities/ProtectedRoute';
import Navbar from './components/Navbar';
import Sidebar from './components/SideBar'; // Import your Sidebar component
import Mantenimiento from "./components/Mantenimiento";
import Combustibles from "./components/Combustibles";
//import Viajes from "./components/Viajes";
import Dashboard from "./components/Dashboard";
import Infracciones from "./components/Infracciones";
import Documentos from "./components/Documentos";

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <div style={{ display: "flex", background: "#f9f9f9", height: "100vh" }}>
      {/* Show Sidebar only if it's NOT the login page */}
      {!isLoginPage && <Sidebar />}

      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Show Navbar only if it's NOT the login page */}
        {!isLoginPage && <Navbar />}

        <Routes>
          <Route path="/login" element={<SignIn />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Dashboard />
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/vehiculos"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Vehiculos />
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/conductores"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Conductores />
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/mantenimiento"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Mantenimiento />
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/combustibles"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Combustibles />
                </div>
              </ProtectedRoute>
            }
          />

          {/*
          <Route
            path="/viajes"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Viajes />
                </div>
              </ProtectedRoute>
            }
          />
          */}
          
          <Route
            path="/infracciones"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Infracciones />
                </div>
              </ProtectedRoute>
            }
          />

          <Route
            path="/documentos"
            element={
              <ProtectedRoute>
                <div style={{ marginTop: "60px", padding: '1.5em'}}>
                  <Documentos />
                </div>
              </ProtectedRoute>
            }
          />

        </Routes>
      </div>
    </div>
  );
}

export default App;